import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

let ourOffice = document.querySelector('.our-offices');

if(ourOffice) {
    contactAnimateInit();
}

function contactAnimateInit() {
    let contactImage = gsap.utils.toArray('.our-offices__items-image');
    let contactContent = gsap.utils.toArray('.our-offices__items-content');

    function toggleClassElement(item, elClass) {
        item.classList.add(elClass)
    }

    contactImage.forEach((item) => {
        ScrollTrigger.create({
            trigger: item,
            start: 'top 60%',
            // end: 'bottom 30%',
            // toggleClass: 'active',
            // toggleActions: "restart none none none",
            // markers: true,

            onEnter: () => toggleClassElement(item, 'our-offices__items-image--active'),
            // onLeaveBack: () => toggleClassElement(item, 'our-offices__items-image--active'),
        })
    })

    contactContent.forEach((item) => {
        ScrollTrigger.create({
            trigger: item,
            start: 'top 60%',
            // end: 'bottom 30%',
            // toggleClass: 'active',
            // toggleActions: "restart none none none",
            // markers: true,

            onEnter: () => toggleClassElement(item, 'our-offices__items-content--active'),
            // onLeaveBack: () => toggleClassElement(item, 'our-offices__items-image--active'),
        })
    })
}